/** Headers STOMP frame */
export type StompFrameHeaders = Record<string, string> & {message?: string};

/**
 * SockJS возвращает объект, совместимый с WebSocket по контракту.
 * STOMP Client ожидает WebSocket — приведение типа централизовано здесь.
 * eslint-disable-next-line @typescript-eslint/consistent-type-assertions
 */
export function toWebSocket(sockJsInstance: unknown): WebSocket {
	return sockJsInstance as WebSocket;
}
